import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#003974' ,
                secondary: '#bf8d13',
                danger:"#EF5350",
            }
        }
    }
});
